import { render, staticRenderFns } from "./GuppyChatPostsConversationList.vue?vue&type=template&id=74d0ddf4&"
import script from "./GuppyChatPostsConversationList.vue?vue&type=script&lang=js&"
export * from "./GuppyChatPostsConversationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports